import { MapGroupId } from "../../types";
import img from "../../mapImages/ReserveMain2D.webp";

const mapData = {
  groupId: MapGroupId.Reserve,
  groupName: {
    en: "Reserve",
    ru: "Резерв ",
  },
  title: {
    en: "Main 2D",
    ru: "Главная 2D",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
